import i18n from '../i18n'

export default {
  day: [
    { value: 1, name: '01' },
    { value: 2, name: '02' },
    { value: 3, name: '03' },
    { value: 4, name: '04' },
    { value: 5, name: '05' },
    { value: 6, name: '06' },
    { value: 7, name: '07' },
    { value: 8, name: '08' },
    { value: 9, name: '09' },
    { value: 10, name: '10' },
    { value: 11, name: '11' },
    { value: 12, name: '12' },
    { value: 13, name: '13' },
    { value: 14, name: '14' },
    { value: 15, name: '15' },
    { value: 16, name: '16' },
    { value: 17, name: '17' },
    { value: 18, name: '18' },
    { value: 19, name: '19' },
    { value: 20, name: '20' },
    { value: 21, name: '21' },
    { value: 22, name: '22' },
    { value: 23, name: '23' },
    { value: 24, name: '24' },
    { value: 25, name: '25' },
    { value: 26, name: '26' },
    { value: 27, name: '27' },
    { value: 28, name: '28' },
    { value: 29, name: '29' },
    { value: 30, name: '30' }
  ],
  month: [
    { value: 0, name: 'Jan' },
    { value: 1, name: 'Feb' },
    { value: 2, name: 'Mar' },
    { value: 3, name: 'Apr' },
    { value: 4, name: 'May' },
    { value: 5, name: 'Jun' },
    { value: 6, name: 'Jul' },
    { value: 7, name: 'Aug' },
    { value: 8, name: 'Sep' },
    { value: 9, name: 'Oct' },
    { value: 10, name: 'Nov' },
    { value: 11, name: 'Dec' }
  ],
  year: [
    { value: 2023, name: '2023' },
    { value: 2022, name: '2022' },
    { value: 2021, name: '2021' },
    { value: 2020, name: '2020' },
    { value: 2019, name: '2019' },
    { value: 2018, name: '2018' },
    { value: 2017, name: '2017' },
    { value: 2016, name: '2016' },
    { value: 2015, name: '2015' },
    { value: 2014, name: '2014' },
    { value: 2013, name: '2013' },
    { value: 2012, name: '2012' },
    { value: 2011, name: '2011' },
    { value: 2010, name: '2010' }
  ],
  quarter: [
    { value: 1, name: 'Q1' },
    { value: 2, name: 'Q2' },
    { value: 3, name: 'Q3' },
    { value: 4, name: 'Q4' }
  ],
  time: [
    { value: 'am', name: 'am' },
    { value: 'pm', name: 'pm' }
  ],
  min: [
    { value: 0, name: '00' },
    { value: 5, name: '5' },
    { value: 10, name: '10' },
    { value: 15, name: '15' },
    { value: 20, name: '20' },
    { value: 25, name: '25' },
    { value: 30, name: '10' },
    { value: 35, name: '35' },
    { value: 40, name: '40' },
    { value: 45, name: '45' },
    { value: 50, name: '50' },
    { value: 55, name: '55' }
  ],
  hours: [
    { value: 1, name: '1' },
    { value: 2, name: '2' },
    { value: 3, name: '3' },
    { value: 4, name: '4' },
    { value: 5, name: '5' },
    { value: 6, name: '6' },
    { value: 7, name: '7' },
    { value: 8, name: '8' },
    { value: 9, name: '9' },
    { value: 10, name: '10' },
    { value: 11, name: '11' },
    { value: 12, name: '12' }
  ],
  dateTabs: [
    {
      name: i18n.t('compare_date'),
      id: 0
    },
    {
      name: i18n.t('date_range'),
      id: 1
    }
  ],
  dateRangeTabs: [
    {
      name: i18n.t('year'),
      id: 0
    },
    {
      name: i18n.t('month'),
      id: 2
    },
    {
      name: i18n.t('week'),
      id: 3
    },
    {
      name: i18n.t('day'),
      id: 4
    }
  ]
}
